import { render, staticRenderFns } from "./secondWidget.vue?vue&type=template&id=c3226592"
import script from "./secondWidget.vue?vue&type=script&lang=js"
export * from "./secondWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports